<template>

  <div class="panel-content" id="report-content">
    <div class="photo-section" v-if="images.length">
      <div class="photo-section-label">Фото в отчёте (при наличии)</div>
      <div class="photo-strip">
        <div v-for="image in images" :class="`photo-thumb`+(image.select?' selected':'')"
             @click="image.select=!image.select">
          <img :src="image.value" alt="">
        </div>
      </div>
    </div>
    <div v-if="data.length" v-for="pdf in data">
      <div class="controls-bar">Полей: {{ Object.keys(pdf.json_data).length }},
        {{ $moment(pdf.date_create).format("DD.MM.YYYY HH:mm") }}
      <button class="btn btn-sm" @click="remove_pdf = pdf; $modal('show', 'delete_report');">
        <i class="bi bi-trash text-danger"></i>
      </button>
      </div>
      <table>
        <thead>
        <tr>
          <th width="30"></th>
          <th>Поле</th>
          <th>Значение</th>
          <th>Статусы</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(field, key) in pdf.json_data">
          <tr :class="field.select?'row-selected':''" v-if="key!=='image'">
            <td><input type="checkbox" v-model="field.select"></td>
            <td><b>{{ convertName(key) }}</b></td>
            <td>
              <div v-if="Array.isArray(field.value)" class="array-field">
                <span class="array-count">[{{field.value.filter(x=>x.select).length}}/{{field.value.length}} выбр.]</span>
                <span class="array-badges"></span>
                <button class="btn btn-sm btn-info" @click="field.open=!field.open">
                  <template v-if="!field.open">Открыть →</template><template v-else>Закрыть ↑</template>
                </button>
              </div>
              <span v-else>
                <template v-if="field.flags">
                {{ field.value.value }}
              </template>
                <template v-else>
                  {{ field.value }}
                </template>

                </span>
            </td>
            <td>
              <template v-if="field.flags">
                <span v-for="flag in field.flags.value" class="badge" :style="{backgroundColor: flag.color.value + '20', color: flag.color.value, borderColor: flag.color.value}">{{ flag.name.value }}</span>
              </template>
            </td>
          </tr>
          <tr v-if="Array.isArray(field.value)" v-show="field.open">
            <td colspan="4">
              <PdfArray :field="field"></PdfArray>

            </td>
          </tr>
        </template>

        </tbody>
      </table>
    </div>
    <div v-else style="padding:60px; text-align:center; color:#999; font-size:16px;">Загрузите и обработайте файлы</div>
      <modal modal_id="delete_report">
      <template v-slot:header>
        <h2>
          Удалить отчет?
        </h2>
      </template>

      <template v-slot:body>
        <div class="mb-4" v-if="remove_pdf">
          <p>
            Полей: {{ Object.keys(remove_pdf.json_data).length }}<br>
            Дата загрузки: {{ $moment(remove_pdf.date_create).format("DD.MM.YYYY HH:mm") }}
          </p>
        </div>

      </template>
      <template v-slot:footer>
          <button class="btn btn-sm btn-secondary" @click="$modal('hide', 'delete_report');">Отмена</button>
          <button class="btn btn-sm btn-dark" @click="removeFunction(this.remove_pdf.id); this.remove_pdf=null">Удалить</button>
      </template>
    </modal>
  </div>


</template>

<script>


import PdfArray from "@/views/projects/pdf/components/PdfArray.vue";

export default {
  name: 'PdfFields',
  components: {PdfArray},
  props: {
    data: {type: Array, default: []},
    removeFunction: {type: Function},
  },
  data() {
    return {
      remove_pdf: null
    }
  },
  mounted: function () {

  },
  computed:{
    images(){
      return this.data.filter(x=>Object.keys(x.json_data).indexOf("image")+1).map(x=>x.json_data.image)
    }
  },
  methods: {
    convertName(name){
      name = name.replaceAll('_', " ")
      return String(name).charAt(0).toUpperCase() + String(name).slice(1);
    }
  }
}

</script>

<style scoped lang="scss">

.photo-section {
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  background: #fafbfc;
}

.photo-section-label {
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.photo-strip {
  display: flex;
  gap: 10px;
  overflow-x: auto;
}

.photo-thumb {
  width: 60px;
  height: 60px;
  background-size: cover;
  background-position: center;
  border-radius: 4px;
  border: 2px dashed #ccc;
  cursor: pointer;
  opacity: 0.7;
  position: relative;
  img{
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
}

.photo-thumb:hover {
  opacity: 0.9;
  border-color: #aaa;
}

.photo-thumb.selected {
  border: 2px solid #3498db;
  opacity: 1;
}

.photo-thumb.selected::after {
  content: '✓';
  position: absolute;
  top: -6px;
  right: -6px;
  background: #3498db;
  color: #fff;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.controls-bar {
  padding: 8px 15px;
  background: #f1f3f5;
  border-bottom: 1px solid #ddd;
  font-size: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin-bottom: 100px;
}

th, td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

th {
  background: #f8f9fa;
  //position: sticky;
  top: 0;
  z-index: 10;
  font-weight: 600;
  font-size: 12px;
}

.row-selected {
  background: #f0f7ff;
}

.badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  margin-right: 3px;
    background: #ffebee;
  color: #c62828;
  border: 1px solid #ef9a9a;
}

.array-field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.array-count {
  color: #666;
  font-size: 11px;
}

.array-badges {
  display: flex;
  gap: 2px;
}

</style>
